export const UNCATEGORIZED_SKETCHUP_HELP_AGGREGATION = "uncategorized_sketchup_help";
export var FilterTypeEnum;
(function (FilterTypeEnum) {
    FilterTypeEnum["ALL"] = "all";
    FilterTypeEnum["ANY"] = "any";
    FilterTypeEnum["NONE"] = "none";
})(FilterTypeEnum || (FilterTypeEnum = {}));
export var SortDirectionEnum;
(function (SortDirectionEnum) {
    SortDirectionEnum["ASCENDING"] = "asc";
    SortDirectionEnum["DESCENDING"] = "desc";
})(SortDirectionEnum || (SortDirectionEnum = {}));
export var FilterOptionEnum;
(function (FilterOptionEnum) {
    FilterOptionEnum["PRODUCT"] = "product";
    FilterOptionEnum["VERSION"] = "software_version";
    FilterOptionEnum["CONTENT_AREA"] = "content_area";
    FilterOptionEnum["AREA"] = "area";
    FilterOptionEnum["CATEGORY"] = "content_type";
    FilterOptionEnum["TYPE"] = "type";
    FilterOptionEnum["INFORMATION_TYPE"] = "information_type";
    FilterOptionEnum["ENVIRONMENT"] = "environment";
    FilterOptionEnum["TAGS"] = "tags";
    FilterOptionEnum["DEVICE"] = "device";
})(FilterOptionEnum || (FilterOptionEnum = {}));
export var ResultTypeEnum;
(function (ResultTypeEnum) {
    ResultTypeEnum["ARTICLE"] = "Article";
    ResultTypeEnum["BULLETIN"] = "Bulletin";
    ResultTypeEnum["COMPONENT_HELP"] = "Component help";
    ResultTypeEnum["COURSE"] = "Course";
    ResultTypeEnum["INTERNAL_ARTICLE"] = "Internal article";
    ResultTypeEnum["PRODUCT_GUIDE"] = "Product guide";
    ResultTypeEnum["RELEASE_NOTES"] = "Release notes";
    ResultTypeEnum["VIDEO"] = "Video";
})(ResultTypeEnum || (ResultTypeEnum = {}));
export var ServiceEnum;
(function (ServiceEnum) {
    ServiceEnum["TRIMBLE_HELP"] = "thlp";
    ServiceEnum["SKETCHUP_HELP"] = "shlp";
    // DOWNLOAD = "down",
})(ServiceEnum || (ServiceEnum = {}));
